import Checkbox from 'components/checkbox'
import TagCandidateDestination from 'entities/user_notice/tag_destination_candidate'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './list_item.module.scss'

const TagListItem = ({ isChecked, tag, onChange }) => {
  const formId = `user-notice-content-destination-tag-${tag.id}`

  return (
    <div className={styles.row} key={tag.id}>
      <div className={styles.checkbox}>
        <Checkbox
          checkboxId={formId}
          checkboxName="tag[id][]"
          defaultValue={tag.id}
          isChecked={isChecked}
          onChange={() => onChange(tag.id)}
        />
      </div>
      <label className={styles.tagNames} htmlFor={formId}>
        <span className={styles.tagName}>{tag.name}</span>
        <span className={styles.tagCount}>
          {I18n.t('components.destinations_field.tag_list_item.recruiters_count', {
            recruiters_count: tag.recruitersCount
          })}
        </span>
      </label>
    </div>
  )
}

TagListItem.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  tag: PropTypes.instanceOf(TagCandidateDestination).isRequired,
  onChange: PropTypes.func.isRequired
}

export default TagListItem
